// extracted by mini-css-extract-plugin
module.exports = {"bar":"modalBackground_bar__3iUCw","big":"modalBackground_big__OBWsn","small":"modalBackground_small__2zl1N","tiny":"modalBackground_tiny__2rF44"};